import { HERO_STAGES, HERO_SIDEBAR } from "../../mock";

// El Hero está fijo. Texto izquierdo + sidebar derecho NO se mueven
// con el scroll. Solo el video de fondo (en VideoBackdrop) avanza
// al scrollear, y al pasar 80% suben las secciones de abajo.
export default function Hero() {
  const stage = HERO_STAGES[0];

  return (
    <section
      id="top"
      style={{
        position: "relative",
        height: "350vh",
        zIndex: 1,
      }}
    >
      <div
        style={{
          position: "sticky",
          top: 0,
          width: "100%",
          height: "100vh",
          overflow: "hidden",
        }}
      >
        <div
          className="hero-grid"
          style={{
            position: "relative",
            zIndex: 2,
            maxWidth: 1440,
            margin: "0 auto",
            height: "100%",
            padding: "0 40px",
            display: "grid",
            gridTemplateColumns: "38% 1fr 26%",
            gap: 32,
            alignItems: "center",
          }}
        >
          {/* LEFT — copy fijo */}
          <div style={{ position: "relative" }}>
            <div className="eyebrow" style={{ marginBottom: 22 }}>
              {stage.eyebrow}
            </div>
            <h1
              className="font-display"
              style={{
                fontSize: "clamp(2.8rem, 5.4vw, 5.6rem)",
                fontWeight: 700,
                lineHeight: 0.96,
                letterSpacing: "-0.045em",
                margin: 0,
                marginBottom: 24,
                color: "var(--ink)",
                hyphens: "manual",
                overflowWrap: "break-word",
              }}
            >
              {stage.title}{" "}
              <em
                style={{
                  fontStyle: "italic",
                  fontWeight: 500,
                  color: "var(--ink)",
                }}
              >
                {stage.accent}
              </em>
            </h1>
            <p
              style={{
                fontSize: 16,
                lineHeight: 1.55,
                color: "var(--ink-dim)",
                margin: 0,
                marginBottom: stage.cta ? 28 : 0,
                maxWidth: 420,
              }}
            >
              {stage.body}
            </p>
            {stage.cta && (
              <div className="hero-cta-row">
                <a
                  href="https://lorena.soypacoia.com/"
                  target="_blank"
                  rel="noreferrer"
                  className="btn-whatsapp"
                >
                  Prueba asistente WhatsApp 24/7
                </a>
                <a
                  href="https://payhip.com/SoyPacoIA"
                  target="_blank"
                  rel="noreferrer"
                  className="btn-ghost"
                >
                  Recursos IA
                </a>
                <a href="#contacto" className="hero-cta-tertiary">
                  Agenda una llamada →
                </a>
              </div>
            )}
            {stage.cta && (
              <div className="flex items-center justify-center gap-2 mt-8 px-4 py-2 bg-white/80 backdrop-blur-sm rounded-full border border-gray-200 shadow-sm mx-auto w-fit">
                <svg className="w-5 h-5 flex-shrink-0" viewBox="0 0 24 24" fill="#25D366" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                <span className="text-sm font-medium text-gray-700">Verified WhatsApp Tech Provider</span>
                <svg className="w-4 h-4 text-green-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
                </svg>
              </div>
            )}
          </div>

          {/* CENTER — vacío para dejar respirar el video */}
          <div />

          {/* RIGHT — sidebar fijo */}
          <div
            style={{
              position: "relative",
              textAlign: "right",
              fontFamily: '"DM Sans", sans-serif',
            }}
          >
            {HERO_SIDEBAR.map((item, idx) => {
              if (item.type === "spacer") {
                return <div key={idx} style={{ height: 24 }} />;
              }
              if (item.type === "label") {
                return (
                  <div
                    key={idx}
                    style={{
                      fontSize: 10,
                      fontWeight: 500,
                      letterSpacing: "0.22em",
                      textTransform: "uppercase",
                      color: "var(--ink-mute)",
                      marginBottom: 10,
                    }}
                  >
                    {item.text}
                  </div>
                );
              }
              if (item.type === "hero") {
                return (
                  <div
                    key={idx}
                    className="font-display"
                    style={{
                      fontSize: 22,
                      fontWeight: 500,
                      lineHeight: 1.18,
                      color: "var(--ink)",
                      marginBottom: 6,
                    }}
                  >
                    {item.text}
                  </div>
                );
              }
              if (item.type === "body") {
                return (
                  <div
                    key={idx}
                    style={{
                      fontSize: 14,
                      lineHeight: 1.5,
                      color: "var(--ink-dim)",
                      marginBottom: 12,
                      maxWidth: 280,
                      marginLeft: "auto",
                    }}
                  >
                    {item.text}
                  </div>
                );
              }
              if (item.type === "link") {
                return (
                  <a
                    key={idx}
                    href={item.url}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      display: "block",
                      fontSize: 13,
                      color: "var(--ink-dim)",
                      padding: "6px 0",
                      borderBottom: "1px solid var(--line)",
                      textDecoration: "none",
                      transition: "color 0.2s",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.color = "var(--ink)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.color = "var(--ink-dim)";
                    }}
                  >
                    {item.text}
                  </a>
                );
              }
              if (item.type === "muted") {
                return (
                  <div
                    key={idx}
                    style={{
                      fontSize: 13,
                      color: "var(--ink-dim)",
                      padding: "6px 0",
                      borderBottom: "1px solid var(--line)",
                    }}
                  >
                    {item.text}
                  </div>
                );
              }
              return null;
            })}
          </div>
        </div>

        {/* Bottom-right scroll hint */}
        <div
          style={{
            position: "absolute",
            bottom: 28,
            right: 40,
            fontFamily: '"DM Sans", sans-serif',
            fontSize: 11,
            letterSpacing: "0.18em",
            textTransform: "uppercase",
            color: "var(--ink-dim)",
            display: "flex",
            alignItems: "center",
            gap: 8,
            zIndex: 3,
          }}
        >
          <span style={{ display: "inline-block", lineHeight: 1 }}>↓</span>
          <span>Scroll to explore</span>
        </div>
      </div>

      <style>{`
        .hero-cta-row {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 12px;
        }
        .hero-cta-tertiary {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          font-family: "DM Sans", sans-serif;
          font-size: 13px;
          font-weight: 500;
          color: var(--ink-dim);
          padding: 10px 6px;
          transition: color 0.2s ease;
        }
        .hero-cta-tertiary:hover {
          color: var(--ink);
        }
        @media (max-width: 900px) {
          .hero-cta-row {
            flex-direction: column;
            align-items: stretch;
          }
          .hero-cta-row > a {
            width: 100%;
            justify-content: center;
            text-align: center;
          }
        }
        @media (max-width: 1100px) {
          .hero-grid {
            grid-template-columns: 44% 1fr 24% !important;
          }
        }
        @media (max-width: 900px) {
          .hero-grid {
            grid-template-columns: 1fr !important;
            padding: 100px 24px 60px !important;
          }
          .hero-grid > div:nth-child(2),
          .hero-grid > div:nth-child(3) {
            display: none !important;
          }
        }
      `}</style>
    </section>
  );
}
